<div class="footer">
  <div>{{currentDate | date:'yyyy'}} © Norder</div>
  <div class="links">
    <span class="nav cursor-pointer" (click)="openModalInfo('termsOfService')">Terms of Service</span>
    &nbsp;&nbsp;{{ '|' }}&nbsp;&nbsp;
    <span class="nav cursor-pointer" (click)="openModalInfo('privacyPolicy')">Privacy Policy</span>
  </div>
</div>
